import WebFooter from "../../../components/website/webFooter/WebFooter";
import WebHeader from "../../../components/website/webHeader/WebHeader";

export default function Home() {
  return (
    <>
      <WebHeader />

      <div className="page active" id="page-home">
        {/* HERO */}
        <section className="hero">
          <div className="hero-bg" />
          <div className="wrap hero-inner">
            <span className="eyebrow">
              <span className="dot" />
              Now live in 1,200+ properties across India
            </span>
            <h1 style={{ marginTop: 20 }}>
              PG &amp; rental management,
              <br />
              <span className="accent">finally sorted.</span>
            </h1>
            <p className="sub">
              MyRentMitra runs your property the way you would — if you had ten
              hands. Beds, rent, food, complaints, vacate notices, payments —
              one dashboard. Zero spreadsheets.
            </p>
            <div className="hero-ctas">
              <button
                className="btn btn-primary btn-lg"
                onclick="goTo('auth','signup')"
              >
                Start free trial
                <svg
                  className="arrow"
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </button>
              <button className="btn btn-lg" onclick="goTo('contact')">
                <svg
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path d="M23 7l-7 5 7 5V7zM14 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z" />
                </svg>
                Book a demo
              </button>
            </div>
            <div className="hero-trust">
              <span className="hero-trust-item">
                <svg
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                14-day free trial
              </span>
              <span className="hero-trust-item">
                <svg
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                No credit card
              </span>
              <span className="hero-trust-item">
                <svg
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                Setup in 10 minutes
              </span>
            </div>
            {/* Dashboard screenshot mock */}
            <div className="hero-mock">
              <div className="hero-mock-frame">
                <svg
                  className="mock"
                  viewBox="0 0 1200 680"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="xMidYMid meet"
                  role="img"
                  aria-label="NestManager dashboard preview"
                >
                  <defs>
                    <linearGradient id="h_bg" x1={0} y1={0} x2={0} y2={1}>
                      <stop offset={0} stopColor="#fff" />
                      <stop offset={1} stopColor="#f5f5f3" />
                    </linearGradient>
                    <linearGradient id="h_chart" x1={0} y1={0} x2={0} y2={1}>
                      <stop offset={0} stopColor="#0F6E56" stopOpacity="0.35" />
                      <stop offset={1} stopColor="#0F6E56" stopOpacity={0} />
                    </linearGradient>
                    <linearGradient id="h_chart2" x1={0} y1={0} x2={0} y2={1}>
                      <stop offset={0} stopColor="#185FA5" stopOpacity="0.35" />
                      <stop offset={1} stopColor="#185FA5" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <rect width={1200} height={680} fill="url(#h_bg)" rx={18} />
                  {/* Top bar */}
                  <rect x={0} y={0} width={1200} height={48} fill="#fff" />
                  <line
                    x1={0}
                    y1={48}
                    x2={1200}
                    y2={48}
                    stroke="rgba(0,0,0,0.08)"
                    strokeWidth={1}
                  />
                  <circle cx={22} cy={24} r={5} fill="#FF5F57" />
                  <circle cx={40} cy={24} r={5} fill="#FEBC2E" />
                  <circle cx={58} cy={24} r={5} fill="#28C840" />
                  <rect
                    x={96}
                    y={14}
                    width={8}
                    height={20}
                    rx={2}
                    fill="#0F6E56"
                  />
                  <text
                    x={112}
                    y={30}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={13}
                    fontWeight={700}
                    fill="#1a1a18"
                  >
                    NestManager
                  </text>
                  <rect
                    x={500}
                    y={12}
                    width={200}
                    height={24}
                    rx={6}
                    fill="#f5f5f3"
                  />
                  <text
                    x={514}
                    y={28}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={11}
                    fill="#888780"
                  >
                    ⌕ Search tenants, rooms…
                  </text>
                  <circle cx={1150} cy={24} r={12} fill="#185FA5" />
                  <text
                    x={1150}
                    y={28}
                    textAnchor="middle"
                    fontFamily="Plus Jakarta Sans"
                    fontSize={10}
                    fontWeight={700}
                    fill="#fff"
                  >
                    RV
                  </text>
                  <rect
                    x={1110}
                    y={14}
                    width={24}
                    height={20}
                    rx={4}
                    fill="#fff"
                    stroke="rgba(0,0,0,0.12)"
                  />
                  <text
                    x={1122}
                    y={28}
                    textAnchor="middle"
                    fontFamily="Plus Jakarta Sans"
                    fontSize={11}
                    fill="#5f5e5a"
                  >
                    🔔
                  </text>
                  {/* Sidebar */}
                  <rect x={0} y={48} width={220} height={632} fill="#fff" />
                  <line
                    x1={220}
                    y1={48}
                    x2={220}
                    y2={680}
                    stroke="rgba(0,0,0,0.08)"
                  />
                  <text
                    x={24}
                    y={84}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={10}
                    fontWeight={700}
                    fill="#888780"
                    letterSpacing={1}
                  >
                    MAIN
                  </text>
                  <g fontFamily="Plus Jakarta Sans" fontSize={12}>
                    <rect
                      x={16}
                      y={94}
                      width={188}
                      height={30}
                      rx={6}
                      fill="#E1F5EE"
                    />
                    <text x={36} y={114} fill="#0F6E56" fontWeight={600}>
                      ◇ Dashboard
                    </text>
                    <text x={36} y={146} fill="#5f5e5a">
                      ⚏ Buildings
                    </text>
                    <text x={36} y={172} fill="#5f5e5a">
                      ⚌ Rooms &amp; Beds
                    </text>
                    <text x={36} y={198} fill="#5f5e5a">
                      ◉ Tenants
                    </text>
                    <text x={36} y={224} fill="#5f5e5a">
                      ₹ Billing
                    </text>
                    <text x={36} y={250} fill="#5f5e5a">
                      🍽 Food Plans
                    </text>
                    <text x={36} y={276} fill="#5f5e5a">
                      ◌ Complaints
                    </text>
                  </g>
                  <text
                    x={24}
                    y={310}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={10}
                    fontWeight={700}
                    fill="#888780"
                    letterSpacing={1}
                  >
                    REPORTS
                  </text>
                  <g fontFamily="Plus Jakarta Sans" fontSize={12}>
                    <text x={36} y={336} fill="#5f5e5a">
                      ≈ Occupancy
                    </text>
                    <text x={36} y={362} fill="#5f5e5a">
                      ☰ Collections
                    </text>
                    <text x={36} y={388} fill="#5f5e5a">
                      ⚙ Settings
                    </text>
                  </g>
                  {/* Main content */}
                  <text
                    x={248}
                    y={92}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={20}
                    fontWeight={700}
                    fill="#1a1a18"
                  >
                    Good morning, Rohit
                  </text>
                  <text
                    x={248}
                    y={112}
                    fontFamily="Plus Jakarta Sans"
                    fontSize={12}
                    fill="#5f5e5a"
                  >
                    Here's what's happening across your 3 PGs today
                  </text>
                  {/* KPI cards row */}
                  <g transform="translate(248,132)">
                    <rect
                      x={0}
                      y={0}
                      width={220}
                      height={92}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={16}
                      y={22}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#5f5e5a"
                      letterSpacing="0.5"
                    >
                      OCCUPIED BEDS
                    </text>
                    <text
                      x={16}
                      y={52}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={26}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      184
                      <tspan fontSize={14} fill="#888780">
                        /208
                      </tspan>
                    </text>
                    <rect
                      x={16}
                      y={64}
                      width={188}
                      height={6}
                      rx={3}
                      fill="#f5f5f3"
                    />
                    <rect
                      x={16}
                      y={64}
                      width={166}
                      height={6}
                      rx={3}
                      fill="#0F6E56"
                    />
                    <text
                      x={16}
                      y={82}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#0F6E56"
                      fontWeight={600}
                    >
                      88.5% occupied ▲ 4%
                    </text>
                    <rect
                      x={232}
                      y={0}
                      width={220}
                      height={92}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={248}
                      y={22}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#5f5e5a"
                      letterSpacing="0.5"
                    >
                      RENT COLLECTED
                    </text>
                    <text
                      x={248}
                      y={52}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={26}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      ₹8.42
                      <tspan fontSize={14} fill="#888780">
                        L
                      </tspan>
                    </text>
                    <text
                      x={248}
                      y={74}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={11}
                      fill="#5f5e5a"
                    >
                      of ₹9.2L this month
                    </text>
                    <text
                      x={248}
                      y={88}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#3B6D11"
                      fontWeight={600}
                    >
                      ▲ 12% vs last month
                    </text>
                    <rect
                      x={464}
                      y={0}
                      width={220}
                      height={92}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={480}
                      y={22}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#5f5e5a"
                      letterSpacing="0.5"
                    >
                      PENDING DUES
                    </text>
                    <text
                      x={480}
                      y={52}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={26}
                      fontWeight={800}
                      fill="#A32D2D"
                    >
                      ₹78K
                    </text>
                    <text
                      x={480}
                      y={74}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={11}
                      fill="#5f5e5a"
                    >
                      from 9 tenants
                    </text>
                    <rect
                      x={480}
                      y={78}
                      width={90}
                      height={14}
                      rx={3}
                      fill="#FCEBEB"
                    />
                    <text
                      x={488}
                      y={88}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={9}
                      fill="#A32D2D"
                      fontWeight={700}
                    >
                      4 overdue ›
                    </text>
                    <rect
                      x={696}
                      y={0}
                      width={220}
                      height={92}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={712}
                      y={22}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#5f5e5a"
                      letterSpacing="0.5"
                    >
                      OPEN TICKETS
                    </text>
                    <text
                      x={712}
                      y={52}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={26}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      6
                    </text>
                    <text
                      x={712}
                      y={74}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={11}
                      fill="#5f5e5a"
                    >
                      2 voice · 4 text
                    </text>
                    <text
                      x={712}
                      y={88}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#BA7517"
                      fontWeight={600}
                    >
                      Avg resolve: 3.2 hrs
                    </text>
                  </g>
                  {/* Collection chart card */}
                  <g transform="translate(248,248)">
                    <rect
                      x={0}
                      y={0}
                      width={552}
                      height={204}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={18}
                      y={26}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={13}
                      fontWeight={700}
                      fill="#1a1a18"
                    >
                      Collection Trend
                    </text>
                    <text
                      x={18}
                      y={42}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={11}
                      fill="#888780"
                    >
                      Last 30 days
                    </text>
                    <g transform="translate(18,56)">
                      <polygon
                        points="0,110 30,95 60,80 90,90 120,60 150,70 180,40 210,50 240,30 270,45 300,20 330,28 360,15 390,22 420,10 450,25 480,18 510,8 510,130 0,130"
                        fill="url(#h_chart)"
                      />
                      <polyline
                        points="0,110 30,95 60,80 90,90 120,60 150,70 180,40 210,50 240,30 270,45 300,20 330,28 360,15 390,22 420,10 450,25 480,18 510,8"
                        fill="none"
                        stroke="#0F6E56"
                        strokeWidth={2}
                      />
                      <polygon
                        points="0,124 30,118 60,114 90,108 120,100 150,96 180,90 210,85 240,80 270,74 300,70 330,64 360,62 390,58 420,52 450,48 480,42 510,36 510,130 0,130"
                        fill="url(#h_chart2)"
                      />
                      <polyline
                        points="0,124 30,118 60,114 90,108 120,100 150,96 180,90 210,85 240,80 270,74 300,70 330,64 360,62 390,58 420,52 450,48 480,42 510,36"
                        fill="none"
                        stroke="#185FA5"
                        strokeWidth="1.5"
                        strokeDasharray="3 3"
                      />
                      <circle cx={510} cy={8} r={4} fill="#0F6E56" />
                      <circle
                        cx={510}
                        cy={8}
                        r={8}
                        fill="#0F6E56"
                        fillOpacity="0.15"
                      />
                    </g>
                    <g
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#888780"
                    >
                      <text x={18} y={196}>
                        Apr 1
                      </text>
                      <text x={140} y={196}>
                        Apr 8
                      </text>
                      <text x={262} y={196}>
                        Apr 15
                      </text>
                      <text x={384} y={196}>
                        Apr 22
                      </text>
                      <text x={488} y={196}>
                        Apr 30
                      </text>
                    </g>
                    <g
                      transform="translate(420,14)"
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                    >
                      <rect
                        x={0}
                        y={0}
                        width={10}
                        height={3}
                        fill="#0F6E56"
                        rx={1}
                      />
                      <text x={16} y={5} fill="#5f5e5a">
                        Collected
                      </text>
                      <rect
                        x={68}
                        y={0}
                        width={10}
                        height={3}
                        fill="#185FA5"
                        rx={1}
                      />
                      <text x={84} y={5} fill="#5f5e5a">
                        Expected
                      </text>
                    </g>
                  </g>
                  {/* Room/bed grid */}
                  <g transform="translate(816,248)">
                    <rect
                      x={0}
                      y={0}
                      width={360}
                      height={204}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={18}
                      y={26}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={13}
                      fontWeight={700}
                      fill="#1a1a18"
                    >
                      UrbanNest · Floor 2
                    </text>
                    <text
                      x={18}
                      y={42}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={11}
                      fill="#888780"
                    >
                      24 beds · 4 vacant
                    </text>
                    <g transform="translate(18,56)">
                      {/* rooms as bed grids */}
                      <g
                        fontFamily="Plus Jakarta Sans"
                        fontSize={9}
                        fill="#fff"
                        fontWeight={600}
                      >
                        <rect
                          x={0}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={20} y={18} textAnchor="middle">
                          201-A
                        </text>
                        <rect
                          x={44}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={64} y={18} textAnchor="middle">
                          201-B
                        </text>
                        <rect
                          x={88}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={108} y={18} textAnchor="middle">
                          201-C
                        </text>
                        <rect
                          x={132}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#BA7517"
                        />
                        <text x={152} y={18} textAnchor="middle">
                          202-A
                        </text>
                        <rect
                          x={176}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={196} y={18} textAnchor="middle">
                          202-B
                        </text>
                        <rect
                          x={220}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#efefec"
                          stroke="rgba(0,0,0,0.12)"
                        />
                        <text x={240} y={18} textAnchor="middle" fill="#888780">
                          203-A
                        </text>
                        <rect
                          x={264}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={284} y={18} textAnchor="middle">
                          203-B
                        </text>
                        <rect
                          x={308}
                          y={0}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={328} y={18} textAnchor="middle">
                          203-C
                        </text>
                        <rect
                          x={0}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={20} y={50} textAnchor="middle">
                          204-A
                        </text>
                        <rect
                          x={44}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#A32D2D"
                        />
                        <text x={64} y={50} textAnchor="middle">
                          204-B
                        </text>
                        <rect
                          x={88}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={108} y={50} textAnchor="middle">
                          205-A
                        </text>
                        <rect
                          x={132}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={152} y={50} textAnchor="middle">
                          205-B
                        </text>
                        <rect
                          x={176}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#efefec"
                          stroke="rgba(0,0,0,0.12)"
                        />
                        <text x={196} y={50} textAnchor="middle" fill="#888780">
                          206
                        </text>
                        <rect
                          x={220}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={240} y={50} textAnchor="middle">
                          207-A
                        </text>
                        <rect
                          x={264}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={284} y={50} textAnchor="middle">
                          207-B
                        </text>
                        <rect
                          x={308}
                          y={32}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={328} y={50} textAnchor="middle">
                          208
                        </text>
                        <rect
                          x={0}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={20} y={82} textAnchor="middle">
                          209-A
                        </text>
                        <rect
                          x={44}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={64} y={82} textAnchor="middle">
                          209-B
                        </text>
                        <rect
                          x={88}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#BA7517"
                        />
                        <text x={108} y={82} textAnchor="middle">
                          210-A
                        </text>
                        <rect
                          x={132}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={152} y={82} textAnchor="middle">
                          210-B
                        </text>
                        <rect
                          x={176}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={196} y={82} textAnchor="middle">
                          211-A
                        </text>
                        <rect
                          x={220}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#efefec"
                          stroke="rgba(0,0,0,0.12)"
                        />
                        <text x={240} y={82} textAnchor="middle" fill="#888780">
                          211-B
                        </text>
                        <rect
                          x={264}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={284} y={82} textAnchor="middle">
                          212-A
                        </text>
                        <rect
                          x={308}
                          y={64}
                          width={40}
                          height={28}
                          rx={5}
                          fill="#0F6E56"
                        />
                        <text x={328} y={82} textAnchor="middle">
                          212-B
                        </text>
                      </g>
                    </g>
                    <g
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#5f5e5a"
                    >
                      <rect
                        x={18}
                        y={170}
                        width={8}
                        height={8}
                        rx={2}
                        fill="#0F6E56"
                      />
                      <text x={30} y={178}>
                        Occupied
                      </text>
                      <rect
                        x={92}
                        y={170}
                        width={8}
                        height={8}
                        rx={2}
                        fill="#BA7517"
                      />
                      <text x={104} y={178}>
                        Due soon
                      </text>
                      <rect
                        x={168}
                        y={170}
                        width={8}
                        height={8}
                        rx={2}
                        fill="#A32D2D"
                      />
                      <text x={180} y={178}>
                        Overdue
                      </text>
                      <rect
                        x={232}
                        y={170}
                        width={8}
                        height={8}
                        rx={2}
                        fill="#efefec"
                        stroke="rgba(0,0,0,0.12)"
                      />
                      <text x={244} y={178}>
                        Vacant
                      </text>
                    </g>
                  </g>
                  {/* Recent activity feed */}
                  <g transform="translate(248,468)">
                    <rect
                      x={0}
                      y={0}
                      width={928}
                      height={192}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={18}
                      y={26}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={13}
                      fontWeight={700}
                      fill="#1a1a18"
                    >
                      Recent activity
                    </text>
                    <rect
                      x={836}
                      y={14}
                      width={78}
                      height={22}
                      rx={5}
                      fill="#f5f5f3"
                    />
                    <text
                      x={875}
                      y={28}
                      textAnchor="middle"
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#5f5e5a"
                      fontWeight={600}
                    >
                      View all ›
                    </text>
                    {/* row 1 */}
                    <g transform="translate(18,50)">
                      <circle cx={12} cy={12} r={12} fill="#E1F5EE" />
                      <text
                        x={12}
                        y={16}
                        textAnchor="middle"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fontWeight={700}
                        fill="#0F6E56"
                      >
                        ₹
                      </text>
                      <text
                        x={36}
                        y={10}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fontWeight={600}
                        fill="#1a1a18"
                      >
                        Priya Sharma
                      </text>
                      <text
                        x={36}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#5f5e5a"
                      >
                        paid ₹12,500 rent for Bed 203-B
                      </text>
                      <text
                        x={860}
                        y={18}
                        textAnchor="end"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={10}
                        fill="#888780"
                      >
                        2 min ago
                      </text>
                      <line
                        x1={0}
                        y1={38}
                        x2={892}
                        y2={38}
                        stroke="rgba(0,0,0,0.06)"
                      />
                    </g>
                    {/* row 2 */}
                    <g transform="translate(18,98)">
                      <circle cx={12} cy={12} r={12} fill="#FAEEDA" />
                      <text
                        x={12}
                        y={16}
                        textAnchor="middle"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fontWeight={700}
                        fill="#BA7517"
                      >
                        ◎
                      </text>
                      <text
                        x={36}
                        y={10}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fontWeight={600}
                        fill="#1a1a18"
                      >
                        New complaint · AC not cooling
                      </text>
                      <text
                        x={36}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#5f5e5a"
                      >
                        Rahul K · Room 204-B · Voice note (42s)
                      </text>
                      <rect
                        x={830}
                        y={5}
                        width={50}
                        height={18}
                        rx={4}
                        fill="#FAEEDA"
                      />
                      <text
                        x={855}
                        y={17}
                        textAnchor="middle"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={9}
                        fontWeight={700}
                        fill="#BA7517"
                      >
                        URGENT
                      </text>
                      <line
                        x1={0}
                        y1={38}
                        x2={892}
                        y2={38}
                        stroke="rgba(0,0,0,0.06)"
                      />
                    </g>
                    {/* row 3 */}
                    <g transform="translate(18,146)">
                      <circle cx={12} cy={12} r={12} fill="#E6F1FB" />
                      <text
                        x={12}
                        y={16}
                        textAnchor="middle"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fontWeight={700}
                        fill="#185FA5"
                      >
                        ◈
                      </text>
                      <text
                        x={36}
                        y={10}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fontWeight={600}
                        fill="#1a1a18"
                      >
                        Vacate notice received
                      </text>
                      <text
                        x={36}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#5f5e5a"
                      >
                        Arjun Mehta · Bed 210-A · Move out May 15
                      </text>
                      <text
                        x={860}
                        y={18}
                        textAnchor="end"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={10}
                        fill="#888780"
                      >
                        1 hr ago
                      </text>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </section>
        {/* Logo strip */}
        <section className="logo-strip">
          <div className="wrap">
            <div className="logo-strip-label">
              Trusted by property owners running
            </div>
            <div className="logo-strip-row">
              <span className="ph">UrbanNest PG</span>
              <span className="ph">ShelterCo</span>
              <span className="ph">StayHQ</span>
              <span className="ph">Nivaas</span>
              <span className="ph">Roomr.in</span>
              <span className="ph">LivIndia</span>
            </div>
          </div>
        </section>
        {/* PROBLEM SECTION */}
        <section className="section problem">
          <div className="wrap">
            <div className="problem-head">
              <span className="eyebrow">
                <span className="dot" />
                Running a PG is 60% admin, 40% actual property
              </span>
              <h2>
                If this is your Monday morning,
                <br />
                we built MyRentMitra for you.
              </h2>
              <p>
                WhatsApp pings, half-filled notebooks, a rent diary that won't
                reconcile, and three tenants at the door — all before breakfast.
              </p>
            </div>
            <div className="problem-grid">
              <div className="problem-card">
                <div className="ic">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                  </svg>
                </div>
                <h3>Tenants in notebooks</h3>
                <p>
                  Names, KYC copies, and deposit amounts scattered across
                  diaries, WhatsApp, and your memory.
                </p>
                <span className="pain">2–3 hrs/day wasted</span>
              </div>
              <div className="problem-card">
                <div className="ic">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6" />
                  </svg>
                </div>
                <h3>Rent chasing marathon</h3>
                <p>
                  Manual reminders, late fees you forget to add, and a month-end
                  reconciliation that eats your Saturday.
                </p>
                <span className="pain">8–12% dues leak</span>
              </div>
              <div className="problem-card">
                <div className="ic">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z" />
                    <path d="M9 22V12h6v10" />
                  </svg>
                </div>
                <h3>Beds, food, guests — all blur</h3>
                <p>
                  Who's in 203-B? Is Arjun on veg plan? Did Room 204 pay? You're
                  the only one who knows. Which is the problem.
                </p>
                <span className="pain">Double-bookings happen</span>
              </div>
              <div className="problem-card">
                <div className="ic">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                  </svg>
                </div>
                <h3>Complaints in 14 places</h3>
                <p>
                  "Sir, AC not working" arrives by WhatsApp, call, knock, and
                  sticky note — and slips through every crack.
                </p>
                <span className="pain">Tenants churn</span>
              </div>
            </div>
          </div>
        </section>
        {/* SOLUTION */}
        <section className="section solution">
          <div className="wrap">
            <div className="solution-inner">
              <div className="solution-copy">
                <span className="eyebrow">
                  <span className="dot" />
                  The fix
                </span>
                <h2>
                  One dashboard. Every room, bed, and rupee — accounted for.
                </h2>
                <p className="lead">
                  MyRentMitra replaces the notebook, the spreadsheet, the
                  WhatsApp group, and the three apps you're already paying for.
                  Your entire operation, clean and queryable.
                </p>
                <div className="solution-bullets">
                  <div className="solution-bullet">
                    <span className="tick">
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={3}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    </span>
                    <div>
                      <strong>Bed-level inventory</strong>
                      <span>
                        Track every single bed, not just rooms. Know who's in,
                        who's due, who's vacating — at a glance.
                      </span>
                    </div>
                  </div>
                  <div className="solution-bullet">
                    <span className="tick">
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={3}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    </span>
                    <div>
                      <strong>Auto rent &amp; reminders</strong>
                      <span>
                        Rent cycles run themselves. SMS, WhatsApp, and email
                        nudges go out on schedule — no more awkward calls.
                      </span>
                    </div>
                  </div>
                  <div className="solution-bullet">
                    <span className="tick">
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={3}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    </span>
                    <div>
                      <strong>Complaints that close</strong>
                      <span>
                        Tenants raise tickets via text or voice note. You
                        triage, assign, and resolve without losing track.
                      </span>
                    </div>
                  </div>
                  <div className="solution-bullet">
                    <span className="tick">
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={3}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 6L9 17l-5-5" />
                      </svg>
                    </span>
                    <div>
                      <strong>Built for India</strong>
                      <span>
                        UPI, DLT-compliant SMS, WhatsApp Business API,
                        multi-language — designed for how PGs actually run here.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <svg
                  className="mock"
                  viewBox="0 0 620 520"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    boxShadow: "var(--sh-lg)",
                    borderRadius: 16,
                    border: "0.5px solid var(--line-mid)",
                    background: "#fff",
                  }}
                >
                  <defs>
                    <linearGradient id="s_bg" x1={0} y1={0} x2={0} y2={1}>
                      <stop offset={0} stopColor="#fff" />
                      <stop offset={1} stopColor="#f5f5f3" />
                    </linearGradient>
                  </defs>
                  <rect width={620} height={520} fill="url(#s_bg)" rx={16} />
                  <g transform="translate(24,24)">
                    <rect
                      x={0}
                      y={0}
                      width={572}
                      height={92}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <circle cx={46} cy={46} r={28} fill="#185FA5" />
                    <text
                      x={46}
                      y={52}
                      textAnchor="middle"
                      fontFamily="Plus Jakarta Sans"
                      fontSize={18}
                      fontWeight={700}
                      fill="#fff"
                    >
                      PS
                    </text>
                    <text
                      x={90}
                      y={38}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={16}
                      fontWeight={700}
                      fill="#1a1a18"
                    >
                      Priya Sharma
                    </text>
                    <text
                      x={90}
                      y={56}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={11}
                      fill="#5f5e5a"
                    >
                      UrbanNest PG · Bed 203-B · Single occupancy
                    </text>
                    <rect
                      x={90}
                      y={64}
                      width={70}
                      height={18}
                      rx={4}
                      fill="#EAF3DE"
                    />
                    <text
                      x={125}
                      y={76}
                      textAnchor="middle"
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={700}
                      fill="#3B6D11"
                    >
                      ● Active
                    </text>
                    <rect
                      x={166}
                      y={64}
                      width={80}
                      height={18}
                      rx={4}
                      fill="#E1F5EE"
                    />
                    <text
                      x={206}
                      y={76}
                      textAnchor="middle"
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={700}
                      fill="#0F6E56"
                    >
                      KYC verified
                    </text>
                    <rect
                      x={476}
                      y={30}
                      width={80}
                      height={32}
                      rx={6}
                      fill="#1a1a18"
                    />
                    <text
                      x={516}
                      y={50}
                      textAnchor="middle"
                      fontFamily="Plus Jakarta Sans"
                      fontSize={11}
                      fontWeight={600}
                      fill="#fff"
                    >
                      Send message
                    </text>
                  </g>
                  <g transform="translate(24,136)">
                    <rect
                      x={0}
                      y={0}
                      width={184}
                      height={76}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={14}
                      y={22}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#888780"
                    >
                      MONTHLY RENT
                    </text>
                    <text
                      x={14}
                      y={46}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={22}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      ₹12,500
                    </text>
                    <text
                      x={14}
                      y={64}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#5f5e5a"
                    >
                      incl. food &amp; utilities
                    </text>
                    <rect
                      x={194}
                      y={0}
                      width={184}
                      height={76}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={208}
                      y={22}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#888780"
                    >
                      DEPOSIT
                    </text>
                    <text
                      x={208}
                      y={46}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={22}
                      fontWeight={800}
                      fill="#1a1a18"
                    >
                      ₹25,000
                    </text>
                    <text
                      x={208}
                      y={64}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#5f5e5a"
                    >
                      held · since Jan 2025
                    </text>
                    <rect
                      x={388}
                      y={0}
                      width={184}
                      height={76}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={402}
                      y={22}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#888780"
                    >
                      NEXT DUE
                    </text>
                    <text
                      x={402}
                      y={46}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={22}
                      fontWeight={800}
                      fill="#3B6D11"
                    >
                      Paid
                    </text>
                    <text
                      x={402}
                      y={64}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#5f5e5a"
                    >
                      May 1 · ₹12,500
                    </text>
                  </g>
                  <g transform="translate(24,232)">
                    <rect
                      x={0}
                      y={0}
                      width={572}
                      height={264}
                      rx={10}
                      fill="#fff"
                      stroke="rgba(0,0,0,0.08)"
                    />
                    <text
                      x={18}
                      y={26}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={13}
                      fontWeight={700}
                      fill="#1a1a18" 
                    >
                      Payment history
                    </text>
                    <line
                      x1={36}
                      y1={58}
                      x2={36}
                      y2={244}
                      stroke="rgba(0,0,0,0.1)"
                      strokeDasharray="2 3"
                    />
                    <circle cx={36} cy={68} r={5} fill="#3B6D11" />
                    <text
                      x={54}
                      y={65}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Apr rent paid · ₹12,500
                    </text>
                    <text
                      x={54}
                      y={80}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#888780"
                    >
                      UPI · Apr 3, 9:42 AM · Receipt #NM-1284
                    </text>
                    <circle cx={36} cy={110} r={5} fill="#3B6D11" />
                    <text
                      x={54}
                      y={107}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Mar rent paid · ₹12,500
                    </text>
                    <text
                      x={54}
                      y={122}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#888780"
                    >
                      UPI · Mar 2, 11:08 AM · Receipt #NM-1109
                    </text>
                    <circle cx={36} cy={152} r={5} fill="#BA7517" />
                    <text
                      x={54}
                      y={149}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Feb rent paid (late)
                    </text>
                    <text
                      x={54}
                      y={164}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#888780"
                    >
                      Cash · Feb 8 · Late fee ₹300
                    </text>
                    <circle cx={36} cy={194} r={5} fill="#3B6D11" />
                    <text
                      x={54}
                      y={191}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Jan rent paid · ₹12,500
                    </text>
                    <text
                      x={54}
                      y={206}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#888780"
                    >
                      UPI · Jan 1 · Receipt #NM-0847
                    </text>
                    <circle cx={36} cy={236} r={5} fill="#0F6E56" />
                    <text
                      x={54}
                      y={233}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={12}
                      fontWeight={600}
                      fill="#1a1a18"
                    >
                      Deposit received · ₹25,000
                    </text>
                    <text
                      x={54}
                      y={248}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fill="#888780"
                    >
                      Bank transfer · Jan 1 · Check-in day
                    </text>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </section>
        {/* FEATURES GRID */}
        <section className="features" id="features">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">
                <span className="dot" />
                Everything in one place
              </span>
              <h2>Six tools, one login.</h2>
              <p>
                From bed allocation to voice-ticket triage — MyRentMitra handles
                the full operational surface of a PG or rental property.
              </p>
            </div>
            <div className="feat-grid">
              <div className="feat feat-lg">
                <div className="feat-ic c-teal">
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M2 4v16M22 4v16M2 8h20M2 16h20M6 12h4M14 12h4" />
                  </svg>
                </div>
                <h3>PG Management — bed by bed</h3>
                <p>
                  Not just rooms — track every individual bed. Know occupancy,
                  due date, sharing type, and tenant history for each. Drag to
                  reassign, block for maintenance, or flag for vacate.
                </p>
                <div className="feat-visual">
                  <svg
                    viewBox="0 0 500 180"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      background: "#fff",
                      display: "block",
                      width: "100%",
                    }}
                  >
                    <g
                      fontFamily="Plus Jakarta Sans"
                      fontSize={10}
                      fontWeight={600}
                      fill="#fff"
                    >
                      <rect
                        x={12}
                        y={12}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={48} y={30} textAnchor="middle">
                        201-A
                      </text>
                      <text
                        x={48}
                        y={44}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Priya S.
                      </text>
                      <rect
                        x={92}
                        y={12}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={128} y={30} textAnchor="middle">
                        201-B
                      </text>
                      <text
                        x={128}
                        y={44}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Nisha R.
                      </text>
                      <rect
                        x={172}
                        y={12}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#BA7517"
                      />
                      <text x={208} y={30} textAnchor="middle">
                        202-A
                      </text>
                      <text
                        x={208}
                        y={44}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.85)"
                      >
                        Due 2d
                      </text>
                      <rect
                        x={252}
                        y={12}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#efefec"
                        stroke="rgba(0,0,0,0.12)"
                      />
                      <text x={288} y={30} textAnchor="middle" fill="#5f5e5a">
                        202-B
                      </text>
                      <text
                        x={288}
                        y={44}
                        textAnchor="middle"
                        fontSize={9}
                        fill="#888780"
                      >
                        Vacant
                      </text>
                      <rect
                        x={332}
                        y={12}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={368} y={30} textAnchor="middle">
                        203-A
                      </text>
                      <text
                        x={368}
                        y={44}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Arjun M.
                      </text>
                      <rect
                        x={412}
                        y={12}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#A32D2D"
                      />
                      <text x={448} y={30} textAnchor="middle">
                        203-B
                      </text>
                      <text
                        x={448}
                        y={44}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.85)"
                      >
                        Overdue
                      </text>
                      <rect
                        x={12}
                        y={60}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={48} y={78} textAnchor="middle">
                        204-A
                      </text>
                      <text
                        x={48}
                        y={92}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Kavya P.
                      </text>
                      <rect
                        x={92}
                        y={60}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#efefec"
                        stroke="rgba(0,0,0,0.12)"
                      />
                      <text x={128} y={78} textAnchor="middle" fill="#5f5e5a">
                        204-B
                      </text>
                      <text
                        x={128}
                        y={92}
                        textAnchor="middle"
                        fontSize={9}
                        fill="#888780"
                      >
                        Vacant
                      </text>
                      <rect
                        x={172}
                        y={60}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={208} y={78} textAnchor="middle">
                        205
                      </text>
                      <text
                        x={208}
                        y={92}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Rohit D.
                      </text>
                      <rect
                        x={252}
                        y={60}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={288} y={78} textAnchor="middle">
                        206-A
                      </text>
                      <text
                        x={288}
                        y={92}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Sanya L.
                      </text>
                      <rect
                        x={332}
                        y={60}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={368} y={78} textAnchor="middle">
                        206-B
                      </text>
                      <text
                        x={368}
                        y={92}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Neha G.
                      </text>
                      <rect
                        x={412}
                        y={60}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={448} y={78} textAnchor="middle">
                        207
                      </text>
                      <text
                        x={448}
                        y={92}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Ishaan V.
                      </text>
                      <rect
                        x={12}
                        y={108}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={48} y={126} textAnchor="middle">
                        208-A
                      </text>
                      <text
                        x={48}
                        y={140}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Tara S.
                      </text>
                      <rect
                        x={92}
                        y={108}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#BA7517"
                      />
                      <text x={128} y={126} textAnchor="middle">
                        208-B
                      </text>
                      <text
                        x={128}
                        y={140}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.85)"
                      >
                        Due 1d
                      </text>
                      <rect
                        x={172}
                        y={108}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={208} y={126} textAnchor="middle">
                        209
                      </text>
                      <text
                        x={208}
                        y={140}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Vikram K.
                      </text>
                      <rect
                        x={252}
                        y={108}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={288} y={126} textAnchor="middle">
                        210-A
                      </text>
                      <text
                        x={288}
                        y={140}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Megha T.
                      </text>
                      <rect
                        x={332}
                        y={108}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#0F6E56"
                      />
                      <text x={368} y={126} textAnchor="middle">
                        210-B
                      </text>
                      <text
                        x={368}
                        y={140}
                        textAnchor="middle"
                        fontSize={9}
                        fill="rgba(255,255,255,0.8)"
                      >
                        Alia K.
                      </text>
                      <rect
                        x={412}
                        y={108}
                        width={72}
                        height={40}
                        rx={6}
                        fill="#efefec"
                        stroke="rgba(0,0,0,0.12)"
                      />
                      <text x={448} y={126} textAnchor="middle" fill="#5f5e5a">
                        211
                      </text>
                      <text
                        x={448}
                        y={140}
                        textAnchor="middle"
                        fontSize={9}
                        fill="#888780"
                      >
                        Vacant
                      </text>
                    </g>
                  </svg>
                </div>
                <div className="feat-tag">Core module</div>
              </div>
              <div className="feat feat-md">
                <div className="feat-ic c-blue">
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H6" />
                  </svg>
                </div>
                <h3>Billing &amp; payments</h3>
                <p>
                  Auto-generated invoices. UPI, cards, net-banking. Deposits,
                  late fees, adjustments — tracked.
                </p>
                <div className="feat-tag">Auto-reconciled</div>
              </div>
              <div className="feat feat-sm">
                <div className="feat-ic c-amber">
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M4 3h16v5H4zM4 11h16v10H4zM9 15h6" />
                  </svg>
                </div>
                <h3>Food management</h3>
                <p>
                  Weekly menu, veg/non-veg plans, guest meals, daily count —
                  delivered to your kitchen.
                </p>
                <div className="feat-tag">PG-only</div>
              </div>
              <div className="feat feat-md">
                <div className="feat-ic c-purple">
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8" />
                  </svg>
                </div>
                <h3>Voice &amp; text tickets</h3>
                <p>
                  Tenants describe problems how they want — typed, voice-noted,
                  or over WhatsApp. You resolve, they rate.
                </p>
                <div className="feat-tag">AI-transcribed</div>
              </div>
              <div className="feat feat-sm">
                <div className="feat-ic c-green">
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <circle cx={12} cy={7} r={4} />
                    <path d="M5 22v-2a7 7 0 0 1 14 0v2" />
                  </svg>
                </div>
                <h3>Tenant records</h3>
                <p>
                  KYC, Aadhaar via DigiLocker, emergency contacts, docs — all
                  linked to the bed.
                </p>
                <div className="feat-tag">DigiLocker ready</div>
              </div>
              <div className="feat feat-sm">
                <div className="feat-ic c-red">
                  <svg
                    width={22}
                    height={22}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
                  </svg>
                </div>
                <h3>Vacate workflow</h3>
                <p>
                  Notice → settlement → deposit refund → re-listing. Clean
                  handover, every time.
                </p>
                <div className="feat-tag">Automated</div>
              </div>
              <div
                className="feat feat-wide"
                style={{
                  background: "linear-gradient(135deg,#1a1a18 0%,#232320 100%)",
                  color: "#fff",
                  borderColor: "#1a1a18",
                  padding: 36,
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1.1fr",
                    gap: 32,
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div
                      className="feat-ic"
                      style={{
                        background: "rgba(255,255,255,0.08)",
                        color: "#fff",
                        border: "0.5px solid rgba(255,255,255,0.15)",
                      }}
                    >
                      <svg
                        width={22}
                        height={22}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path d="M3 3v18h18M7 14l4-4 4 4 5-5" />
                      </svg>
                    </div>
                    <h3 style={{ color: "#fff", fontSize: 22 }}>
                      Analytics that tell you what to fix
                    </h3>
                    <p
                      style={{
                        color: "rgba(255,255,255,0.7)",
                        fontSize: 15,
                        marginTop: 10,
                      }}
                    >
                      Occupancy trends, revenue-per-bed, churn cohorts,
                      collection velocity — explained in plain English, not
                      dashboards-for-dashboards.
                    </p>
                    <div
                      className="feat-tag"
                      style={{ color: "rgba(255,255,255,0.5)" }}
                    >
                      Live across all properties
                    </div>
                  </div>
                  <div>
                    <svg
                      viewBox="0 0 400 200"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ width: "100%", display: "block" }}
                    >
                      <defs>
                        <linearGradient id="an_g" x1={0} y1={0} x2={0} y2={1}>
                          <stop
                            offset={0}
                            stopColor="#0F6E56"
                            stopOpacity="0.6"
                          />
                          <stop
                            offset={1}
                            stopColor="#0F6E56"
                            stopOpacity={0}
                          />
                        </linearGradient>
                      </defs>
                      <rect
                        width={400}
                        height={200}
                        rx={12}
                        fill="rgba(255,255,255,0.04)"
                        stroke="rgba(255,255,255,0.08)"
                      />
                      <text
                        x={20}
                        y={28}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="rgba(255,255,255,0.6)"
                        fontWeight={600}
                      >
                        OCCUPANCY · LAST 6 MONTHS
                      </text>
                      <text
                        x={20}
                        y={58}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={26}
                        fontWeight={800}
                        fill="#fff"
                      >
                        88.5%
                      </text>
                      <text
                        x={120}
                        y={58}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fill="#7CDDC3"
                        fontWeight={700}
                      >
                        ▲ 11.2%
                      </text>
                      <polygon
                        points="20,170 70,140 120,150 170,120 220,105 270,95 320,80 370,70 370,180 20,180"
                        fill="url(#an_g)"
                      />
                      <polyline
                        points="20,170 70,140 120,150 170,120 220,105 270,95 320,80 370,70"
                        fill="none"
                        stroke="#7CDDC3"
                        strokeWidth="2.5"
                      />
                      <g
                        fontFamily="Plus Jakarta Sans"
                        fontSize={9}
                        fill="rgba(255,255,255,0.4)"
                      >
                        <text x={20} y={195}>
                          Nov
                        </text>
                        <text x={70} y={195}>
                          Dec
                        </text>
                        <text x={120} y={195}>
                          Jan
                        </text>
                        <text x={170} y={195}>
                          Feb
                        </text>
                        <text x={220} y={195}>
                          Mar
                        </text>
                        <text x={270} y={195}>
                          Apr
                        </text>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* HOW IT WORKS */}
        <section className="how">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">
                <span className="dot" />
                Setup is not a project
              </span>
              <h2>Live in 10 minutes. Seriously.</h2>
              <p>
                No onboarding call, no IT team, no migration headache. Add your
                properties, import tenants, go.
              </p>
            </div>
            <div className="how-steps">
              <div className="how-step">
                <div className="num">1</div>
                <h3>Add your property</h3>
                <p>One PG, many buildings, a 40-bed hostel — it scales.</p>
              </div>
              <div className="how-step">
                <div className="num">2</div>
                <h3>Map rooms &amp; beds</h3>
                <p>Sharing type, rent, deposit — all per bed.</p>
              </div>
              <div className="how-step">
                <div className="num">3</div>
                <h3>Import tenants</h3>
                <p>Paste from Excel or add one by one. KYC auto-fills.</p>
              </div>
              <div className="how-step">
                <div className="num">4</div>
                <h3>Watch rent land</h3>
                <p>Automated cycles. UPI payments. Done.</p>
              </div>
            </div>
          </div>
        </section>
        {/* PRODUCT SHOWCASE */}
        <section className="showcase">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">
                <span className="dot" />
                Product tour
              </span>
              <h2>See it in motion.</h2>
              <p>
                Each module is designed for the specific moment it shows up in
                your day — not a generic CRM dressed up as property software.
              </p>
            </div>
            <div className="showcase-tabs">
              <button
                className="showcase-tab active"
                data-tab="tab-billing"
                onclick="showcaseTab('tab-billing')"
              >
                Billing
              </button>
              <button
                className="showcase-tab"
                data-tab="tab-food"
                onclick="showcaseTab('tab-food')"
              >
                Food
              </button>
              <button
                className="showcase-tab"
                data-tab="tab-tickets"
                onclick="showcaseTab('tab-tickets')"
              >
                Tickets
              </button>
              <button
                className="showcase-tab"
                data-tab="tab-vacate"
                onclick="showcaseTab('tab-vacate')"
              >
                Vacate
              </button>
            </div>
            <div className="showcase-stage">
              <div className="showcase-frame">
                <div className="showcase-panel active" data-panel="tab-billing">
                  <svg
                    className="mock"
                    viewBox="0 0 1100 560"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width={1100} height={560} fill="#fff" rx={14} />
                    <rect
                      x={24}
                      y={24}
                      width={1052}
                      height={56}
                      rx={8}
                      fill="#f5f5f3"
                    />
                    <text
                      x={42}
                      y={58}
                      fontFamily="Plus Jakarta Sans"
                      fontSize={16}
                      fontWeight={700}
                      fill="#1a1a18"
                    >
                      Billing · April 2025
                    </text>
                    <rect
                      x={950}
                      y={38}
                      width={110}
                      height={30}
                      rx={6}
                      fill="#1a1a18"
                    />
                    <text
                      x={1005}
                      y={57}
                      textAnchor="middle"
                      fontFamily="Plus Jakarta Sans"
                      fontSize={12}
                      fill="#fff"
                      fontWeight={600}
                    >
                      + Generate bills
                    </text>
                    <g transform="translate(24,100)">
                      <rect
                        x={0}
                        y={0}
                        width={340}
                        height={78}
                        rx={10}
                        fill="#E1F5EE"
                      />
                      <text
                        x={20}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#0F6E56"
                        fontWeight={700}
                      >
                        COLLECTED
                      </text>
                      <text
                        x={20}
                        y={54}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={26}
                        fontWeight={800}
                        fill="#1a1a18"
                      >
                        ₹8,42,500
                      </text>
                      <text
                        x={20}
                        y={70}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#5f5e5a"
                      >
                        175 of 184 invoices paid
                      </text>
                      <rect
                        x={356}
                        y={0}
                        width={340}
                        height={78}
                        rx={10}
                        fill="#FAEEDA"
                      />
                      <text
                        x={376}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#BA7517"
                        fontWeight={700}
                      >
                        DUE THIS WEEK
                      </text>
                      <text
                        x={376}
                        y={54}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={26}
                        fontWeight={800}
                        fill="#1a1a18"
                      >
                        ₹46,000
                      </text>
                      <text
                        x={376}
                        y={70}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#5f5e5a"
                      >
                        5 tenants · reminders sent
                      </text>
                      <rect
                        x={712}
                        y={0}
                        width={340}
                        height={78}
                        rx={10}
                        fill="#FCEBEB"
                      />
                      <text
                        x={732}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#A32D2D"
                        fontWeight={700}
                      >
                        OVERDUE
                      </text>
                      <text
                        x={732}
                        y={54}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={26}
                        fontWeight={800}
                        fill="#1a1a18"
                      >
                        ₹32,000
                      </text>
                      <text
                        x={732}
                        y={70}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fill="#5f5e5a"
                      >
                        4 tenants · auto late-fee applied
                      </text>
                    </g>
                    <g transform="translate(24,200)">
                      <rect
                        x={0}
                        y={0}
                        width={1052}
                        height={336}
                        rx={10}
                        fill="#fff"
                        stroke="rgba(0,0,0,0.08)"
                      />
                      <rect
                        x={0}
                        y={0}
                        width={1052}
                        height={40}
                        rx={10}
                        fill="#f5f5f3"
                      />
                      <g
                        fontFamily="Plus Jakarta Sans"
                        fontSize={10}
                        fontWeight={700}
                        fill="#5f5e5a"
                        letterSpacing="0.6"
                      >
                        <text x={20} y={26}>
                          TENANT
                        </text>
                        <text x={240} y={26}>
                          BED
                        </text>
                        <text x={340} y={26}>
                          INVOICE
                        </text>
                        <text x={480} y={26}>
                          AMOUNT
                        </text>
                        <text x={620} y={26}>
                          DUE
                        </text>
                        <text x={760} y={26}>
                          STATUS
                        </text>
                        <text x={920} y={26}>
                          ACTION
                        </text>
                      </g>
                      <g fontFamily="Plus Jakarta Sans" fontSize={12}>
                        <g transform="translate(0,56)">
                          <text x={20} y={0} fill="#1a1a18" fontWeight={600}>
                            Priya Sharma
                          </text>
                          <text x={240} y={0} fill="#5f5e5a">
                            203-B
                          </text>
                          <text
                            x={340}
                            y={0}
                            fill="#5f5e5a"
                            fontFamily="JetBrains Mono"
                            fontSize={11}
                          >
                            NM-1284
                          </text>
                          <text x={480} y={0} fill="#1a1a18" fontWeight={600}>
                            ₹12,500
                          </text>
                          <text x={620} y={0} fill="#5f5e5a">
                            Apr 3
                          </text>
                          <rect
                            x={760}
                            y={-14}
                            width={60}
                            height={20}
                            rx={10}
                            fill="#EAF3DE"
                          />
                          <text
                            x={790}
                            y={0}
                            textAnchor="middle"
                            fill="#3B6D11"
                            fontWeight={700}
                            fontSize={10}
                          >
                            PAID
                          </text>
                          <text x={920} y={0} fill="#185FA5" fontWeight={600}>
                            Receipt
                          </text>
                        </g>
                        <line
                          x1={0}
                          y1={76}
                          x2={1052}
                          y2={76}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <g transform="translate(0,96)">
                          <text x={20} y={0} fill="#1a1a18" fontWeight={600}>
                            Arjun Mehta
                          </text>
                          <text x={240} y={0} fill="#5f5e5a">
                            210-A
                          </text>
                          <text
                            x={340}
                            y={0}
                            fill="#5f5e5a"
                            fontFamily="JetBrains Mono"
                            fontSize={11}
                          >
                            NM-1287
                          </text>
                          <text x={480} y={0} fill="#1a1a18" fontWeight={600}>
                            ₹11,000
                          </text>
                          <text x={620} y={0} fill="#BA7517" fontWeight={600}>
                            Apr 28
                          </text>
                          <rect
                            x={760}
                            y={-14}
                            width={60}
                            height={20}
                            rx={10}
                            fill="#FAEEDA"
                          />
                          <text
                            x={790}
                            y={0}
                            textAnchor="middle"
                            fill="#BA7517"
                            fontWeight={700}
                            fontSize={10}
                          >
                            DUE
                          </text>
                          <text x={920} y={0} fill="#185FA5" fontWeight={600}>
                            Remind
                          </text>
                        </g>
                        <line
                          x1={0}
                          y1={116}
                          x2={1052}
                          y2={116}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <g transform="translate(0,136)">
                          <text x={20} y={0} fill="#1a1a18" fontWeight={600}>
                            Sanya Lakshman
                          </text>
                          <text x={240} y={0} fill="#5f5e5a">
                            206-A
                          </text>
                          <text
                            x={340}
                            y={0}
                            fill="#5f5e5a"
                            fontFamily="JetBrains Mono"
                            fontSize={11}
                          >
                            NM-1290
                          </text>
                          <text x={480} y={0} fill="#1a1a18" fontWeight={600}>
                            ₹13,500
                          </text>
                          <text x={620} y={0} fill="#A32D2D" fontWeight={600}>
                            Apr 22 · 8d late
                          </text>
                          <rect
                            x={760}
                            y={-14}
                            width={80}
                            height={20}
                            rx={10}
                            fill="#FCEBEB"
                          />
                          <text
                            x={800}
                            y={0}
                            textAnchor="middle"
                            fill="#A32D2D"
                            fontWeight={700}
                            fontSize={10}
                          >
                            OVERDUE
                          </text>
                          <text x={920} y={0} fill="#A32D2D" fontWeight={600}>
                            Escalate
                          </text>
                        </g>
                        <line
                          x1={0}
                          y1={156}
                          x2={1052}
                          y2={156}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <g transform="translate(0,176)">
                          <text x={20} y={0} fill="#1a1a18" fontWeight={600}>
                            Ishaan Verma
                          </text>
                          <text x={240} y={0} fill="#5f5e5a">
                            207
                          </text>
                          <text
                            x={340}
                            y={0}
                            fill="#5f5e5a"
                            fontFamily="JetBrains Mono"
                            fontSize={11}
                          >
                            NM-1291
                          </text>
                          <text x={480} y={0} fill="#1a1a18" fontWeight={600}>
                            ₹14,000
                          </text>
                          <text x={620} y={0} fill="#5f5e5a">
                            Apr 5
                          </text>
                          <rect
                            x={760}
                            y={-14}
                            width={60}
                            height={20}
                            rx={10}
                            fill="#EAF3DE"
                          />
                          <text
                            x={790}
                            y={0}
                            textAnchor="middle"
                            fill="#3B6D11"
                            fontWeight={700}
                            fontSize={10}
                          >
                            PAID
                          </text>
                          <text x={920} y={0} fill="#185FA5" fontWeight={600}>
                            Receipt
                          </text>
                        </g>
                        <line
                          x1={0}
                          y1={196}
                          x2={1052}
                          y2={196}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <g transform="translate(0,216)">
                          <text x={20} y={0} fill="#1a1a18" fontWeight={600}>
                            Kavya Pillai
                          </text>
                          <text x={240} y={0} fill="#5f5e5a">
                            204-A
                          </text>
                          <text
                            x={340}
                            y={0}
                            fill="#5f5e5a"
                            fontFamily="JetBrains Mono"
                            fontSize={11}
                          >
                            NM-1292
                          </text>
                          <text x={480} y={0} fill="#1a1a18" fontWeight={600}>
                            ₹12,500
                          </text>
                          <text x={620} y={0} fill="#5f5e5a">
                            Apr 6
                          </text>
                          <rect
                            x={760}
                            y={-14}
                            width={60}
                            height={20}
                            rx={10}
                            fill="#EAF3DE"
                          />
                          <text
                            x={790}
                            y={0}
                            textAnchor="middle"
                            fill="#3B6D11"
                            fontWeight={700}
                            fontSize={10}
                          >
                            PAID
                          </text>
                          <text x={920} y={0} fill="#185FA5" fontWeight={600}>
                            Receipt
                          </text>
                        </g>
                        <line
                          x1={0}
                          y1={236}
                          x2={1052}
                          y2={236}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <g transform="translate(0,256)">
                          <text x={20} y={0} fill="#1a1a18" fontWeight={600}>
                            Rohit Desai
                          </text>
                          <text x={240} y={0} fill="#5f5e5a">
                            205
                          </text>
                          <text
                            x={340}
                            y={0}
                            fill="#5f5e5a"
                            fontFamily="JetBrains Mono"
                            fontSize={11}
                          >
                            NM-1294
                          </text>
                          <text x={480} y={0} fill="#1a1a18" fontWeight={600}>
                            ₹15,000
                          </text>
                          <text x={620} y={0} fill="#BA7517" fontWeight={600}>
                            Apr 30
                          </text>
                          <rect
                            x={760}
                            y={-14}
                            width={60}
                            height={20}
                            rx={10}
                            fill="#FAEEDA"
                          />
                          <text
                            x={790}
                            y={0}
                            textAnchor="middle"
                            fill="#BA7517"
                            fontWeight={700}
                            fontSize={10}
                          >
                            DUE
                          </text>
                          <text x={920} y={0} fill="#185FA5" fontWeight={600}>
                            Remind
                          </text>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="showcase-panel" data-panel="tab-food">
                  <svg
                    className="mock"
                    viewBox="0 0 1100 560"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width={1100} height={560} fill="#fff" rx={14} />
                    <g transform="translate(24,24)">
                      <text
                        x={0}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={18}
                        fontWeight={700}
                        fill="#1a1a18"
                      >
                        Food plan · Week of Apr 21–27
                      </text>
                      <text
                        x={0}
                        y={44}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fill="#5f5e5a"
                      >
                        UrbanNest · 184 tenants · 142 veg · 42 non-veg
                      </text>
                    </g>
                    <g
                      transform="translate(24,88)"
                      fontFamily="Plus Jakarta Sans"
                    >
                      <g
                        fontSize={11}
                        fontWeight={700}
                        fill="#5f5e5a"
                        letterSpacing="0.05em"
                      >
                        <text x={80} y={18} textAnchor="middle">
                          MON
                        </text>
                        <text x={220} y={18} textAnchor="middle">
                          TUE
                        </text>
                        <text x={360} y={18} textAnchor="middle">
                          WED
                        </text>
                        <text x={500} y={18} textAnchor="middle">
                          THU
                        </text>
                        <text x={640} y={18} textAnchor="middle">
                          FRI
                        </text>
                        <text x={780} y={18} textAnchor="middle">
                          SAT
                        </text>
                        <text x={920} y={18} textAnchor="middle">
                          SUN
                        </text>
                      </g>
                      <g fontSize={12} fill="#1a1a18">
                        <text
                          x={0}
                          y={60}
                          fontWeight={700}
                          fill="#BA7517"
                          fontSize={11}
                          letterSpacing="0.05em"
                        >
                          BREAKFAST
                        </text>
                        <rect
                          x={24}
                          y={70}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#FAEEDA"
                        />
                        <text
                          x={80}
                          y={94}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Poha
                        </text>
                        <text
                          x={80}
                          y={110}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + tea, fruit
                        </text>
                        <rect
                          x={164}
                          y={70}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#FAEEDA"
                        />
                        <text
                          x={220}
                          y={94}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Upma
                        </text>
                        <text
                          x={220}
                          y={110}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + sambhar
                        </text>
                        <rect
                          x={304}
                          y={70}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#FAEEDA"
                        />
                        <text
                          x={360}
                          y={94}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Paratha
                        </text>
                        <text
                          x={360}
                          y={110}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + curd, pickle
                        </text>
                        <rect
                          x={444}
                          y={70}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#FAEEDA"
                        />
                        <text
                          x={500}
                          y={94}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Idli · Vada
                        </text>
                        <text
                          x={500}
                          y={110}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + chutney
                        </text>
                        <rect
                          x={584}
                          y={70}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#FAEEDA"
                        />
                        <text
                          x={640}
                          y={94}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Bread · Egg
                        </text>
                        <text
                          x={640}
                          y={110}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + jam, butter
                        </text>
                        <rect
                          x={724}
                          y={70}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#FAEEDA"
                        />
                        <text
                          x={780}
                          y={94}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Dosa
                        </text>
                        <text
                          x={780}
                          y={110}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + chutney
                        </text>
                        <rect
                          x={864}
                          y={70}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#FAEEDA"
                        />
                        <text
                          x={920}
                          y={94}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Aloo Puri
                        </text>
                        <text
                          x={920}
                          y={110}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + halwa
                        </text>
                        <text
                          x={0}
                          y={160}
                          fontWeight={700}
                          fill="#3B6D11"
                          fontSize={11}
                          letterSpacing="0.05em"
                        >
                          LUNCH
                        </text>
                        <rect
                          x={24}
                          y={170}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#EAF3DE"
                        />
                        <text
                          x={80}
                          y={194}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Dal · Rice
                        </text>
                        <text
                          x={80}
                          y={210}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Paneer curry
                        </text>
                        <rect
                          x={164}
                          y={170}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#EAF3DE"
                        />
                        <text
                          x={220}
                          y={194}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Rajma · Rice
                        </text>
                        <text
                          x={220}
                          y={210}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Salad
                        </text>
                        <rect
                          x={304}
                          y={170}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#EAF3DE"
                        />
                        <text
                          x={360}
                          y={194}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Chole · Bhature
                        </text>
                        <text
                          x={360}
                          y={210}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Raita
                        </text>
                        <rect
                          x={444}
                          y={170}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#EAF3DE"
                        />
                        <text
                          x={500}
                          y={194}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Sambhar · Rice
                        </text>
                        <text
                          x={500}
                          y={210}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Veg curry
                        </text>
                        <rect
                          x={584}
                          y={170}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#EAF3DE"
                        />
                        <text
                          x={640}
                          y={194}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Chicken curry
                        </text>
                        <text
                          x={640}
                          y={210}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + roti (non-veg)
                        </text>
                        <rect
                          x={724}
                          y={170}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#EAF3DE"
                        />
                        <text
                          x={780}
                          y={194}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Biryani
                        </text>
                        <text
                          x={780}
                          y={210}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          + salan, raita
                        </text>
                        <rect
                          x={864}
                          y={170}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#EAF3DE"
                        />
                        <text
                          x={920}
                          y={194}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Thali special
                        </text>
                        <text
                          x={920}
                          y={210}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          5 items
                        </text>
                        <text
                          x={0}
                          y={260}
                          fontWeight={700}
                          fill="#185FA5"
                          fontSize={11}
                          letterSpacing="0.05em"
                        >
                          DINNER
                        </text>
                        <rect
                          x={24}
                          y={270}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#E6F1FB"
                        />
                        <text
                          x={80}
                          y={294}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Roti · Sabzi
                        </text>
                        <text
                          x={80}
                          y={310}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Dal
                        </text>
                        <rect
                          x={164}
                          y={270}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#E6F1FB"
                        />
                        <text
                          x={220}
                          y={294}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Pav Bhaji
                        </text>
                        <text
                          x={220}
                          y={310}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Onion rings
                        </text>
                        <rect
                          x={304}
                          y={270}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#E6F1FB"
                        />
                        <text
                          x={360}
                          y={294}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Paneer · Roti
                        </text>
                        <text
                          x={360}
                          y={310}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Jeera rice
                        </text>
                        <rect
                          x={444}
                          y={270}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#E6F1FB"
                        />
                        <text
                          x={500}
                          y={294}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Dal Makhni
                        </text>
                        <text
                          x={500}
                          y={310}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Naan
                        </text>
                        <rect
                          x={584}
                          y={270}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#E6F1FB"
                        />
                        <text
                          x={640}
                          y={294}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Egg curry
                        </text>
                        <text
                          x={640}
                          y={310}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Roti (non-veg)
                        </text>
                        <rect
                          x={724}
                          y={270}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#E6F1FB"
                        />
                        <text
                          x={780}
                          y={294}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Mix veg
                        </text>
                        <text
                          x={780}
                          y={310}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Pulao
                        </text>
                        <rect
                          x={864}
                          y={270}
                          width={112}
                          height={56}
                          rx={8}
                          fill="#E6F1FB"
                        />
                        <text
                          x={920}
                          y={294}
                          textAnchor="middle"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Fried rice
                        </text>
                        <text
                          x={920}
                          y={310}
                          textAnchor="middle"
                          fontSize={10}
                          fill="#888780"
                        >
                          Manchurian
                        </text>
                      </g>
                    </g>
                    <g transform="translate(24,460)">
                      <rect
                        x={0}
                        y={0}
                        width={1052}
                        height={72}
                        rx={10}
                        fill="#f5f5f3"
                        stroke="rgba(0,0,0,0.08)"
                      />
                      <text
                        x={20}
                        y={28}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fontWeight={700}
                        fill="#1a1a18"
                      >
                        Today's kitchen count
                      </text>
                      <g fontFamily="Plus Jakarta Sans" fontSize={13}>
                        <text x={20} y={52} fill="#5f5e5a">
                          Breakfast:{" "}
                          <tspan fontWeight={700} fill="#1a1a18">
                            178
                          </tspan>
                        </text>
                        <text x={160} y={52} fill="#5f5e5a">
                          Lunch:{" "}
                          <tspan fontWeight={700} fill="#1a1a18">
                            184
                          </tspan>
                        </text>
                        <text x={280} y={52} fill="#5f5e5a">
                          Dinner:{" "}
                          <tspan fontWeight={700} fill="#1a1a18">
                            172
                          </tspan>
                        </text>
                        <text x={420} y={52} fill="#5f5e5a">
                          Guests:{" "}
                          <tspan fontWeight={700} fill="#BA7517">
                            +6
                          </tspan>
                        </text>
                        <text x={560} y={52} fill="#5f5e5a">
                          Fasting:{" "}
                          <tspan fontWeight={700} fill="#1a1a18">
                            3
                          </tspan>
                        </text>
                      </g>
                      <rect
                        x={890}
                        y={20}
                        width={148}
                        height={32}
                        rx={6}
                        fill="#1a1a18"
                      />
                      <text
                        x={964}
                        y={40}
                        textAnchor="middle"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fill="#fff"
                        fontWeight={600}
                      >
                        Send to kitchen
                      </text>
                    </g>
                  </svg>
                </div>
                <div className="showcase-panel" data-panel="tab-tickets">
                  <svg
                    className="mock"
                    viewBox="0 0 1100 560"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width={1100} height={560} fill="#fff" rx={14} />
                    <g transform="translate(24,24)">
                      <text
                        x={0}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={18}
                        fontWeight={700}
                        fill="#1a1a18"
                      >
                        Complaints · Open tickets
                      </text>
                      <text
                        x={0}
                        y={44}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fill="#5f5e5a"
                      >
                        6 open · Avg resolution 3.2 hrs · 94% satisfaction
                      </text>
                    </g>
                    <g transform="translate(24,90)">
                      <rect
                        x={0}
                        y={0}
                        width={340}
                        height={446}
                        rx={10}
                        fill="#f5f5f3"
                      />
                      <text
                        x={16}
                        y={28}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fontWeight={700}
                        fill="#BA7517"
                        letterSpacing="0.06em"
                      >
                        NEW · 2
                      </text>
                      <g transform="translate(12,42)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={130}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                        />
                        <rect
                          x={10}
                          y={10}
                          width={56}
                          height={18}
                          rx={4}
                          fill="#FCEBEB"
                        />
                        <text
                          x={38}
                          y={22}
                          textAnchor="middle"
                          fontFamily="Plus Jakarta Sans"
                          fontSize={9}
                          fontWeight={700}
                          fill="#A32D2D"
                        >
                          URGENT
                        </text>
                        <rect
                          x={70}
                          y={10}
                          width={62}
                          height={18}
                          rx={4}
                          fill="#EEEDFE"
                        />
                        <text
                          x={101}
                          y={22}
                          textAnchor="middle"
                          fontFamily="Plus Jakarta Sans"
                          fontSize={9}
                          fontWeight={700}
                          fill="#534AB7"
                        >
                          🎙 VOICE
                        </text>
                        <text
                          x={10}
                          y={50}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          AC not cooling
                        </text>
                        <text
                          x={10}
                          y={68}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Rahul K · Room 204-B
                        </text>
                        <g transform="translate(10,80)">
                          <rect
                            x={0}
                            y={8}
                            width={2}
                            height={8}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={4}
                            y={6}
                            width={2}
                            height={12}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={8}
                            y={3}
                            width={2}
                            height={18}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={12}
                            y={6}
                            width={2}
                            height={12}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={16}
                            y={2}
                            width={2}
                            height={20}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={20}
                            y={8}
                            width={2}
                            height={8}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={24}
                            y={4}
                            width={2}
                            height={16}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={28}
                            y={6}
                            width={2}
                            height={12}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={32}
                            y={2}
                            width={2}
                            height={20}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={36}
                            y={7}
                            width={2}
                            height={10}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={40}
                            y={4}
                            width={2}
                            height={16}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={44}
                            y={6}
                            width={2}
                            height={12}
                            rx={1}
                            fill="#534AB7"
                          />
                          <rect
                            x={48}
                            y={9}
                            width={2}
                            height={6}
                            rx={1}
                            fill="#c8c5dc"
                          />
                          <rect
                            x={52}
                            y={8}
                            width={2}
                            height={8}
                            rx={1}
                            fill="#c8c5dc"
                          />
                          <rect
                            x={56}
                            y={9}
                            width={2}
                            height={6}
                            rx={1}
                            fill="#c8c5dc"
                          />
                          <text
                            x={68}
                            y={17}
                            fontFamily="Plus Jakarta Sans"
                            fontSize={10}
                            fill="#5f5e5a"
                          >
                            0:42 · auto-transcribed
                          </text>
                        </g>
                        <text
                          x={10}
                          y={120}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={10}
                          fill="#888780"
                        >
                          "Sir, AC in my room not working since morning..."
                        </text>
                      </g>
                      <g transform="translate(12,184)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={96}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                        />
                        <rect
                          x={10}
                          y={10}
                          width={56}
                          height={18}
                          rx={4}
                          fill="#FAEEDA"
                        />
                        <text
                          x={38}
                          y={22}
                          textAnchor="middle"
                          fontFamily="Plus Jakarta Sans"
                          fontSize={9}
                          fontWeight={700}
                          fill="#BA7517"
                        >
                          MEDIUM
                        </text>
                        <rect
                          x={70}
                          y={10}
                          width={58}
                          height={18}
                          rx={4}
                          fill="#E6F1FB"
                        />
                        <text
                          x={99}
                          y={22}
                          textAnchor="middle"
                          fontFamily="Plus Jakarta Sans"
                          fontSize={9}
                          fontWeight={700}
                          fill="#185FA5"
                        >
                          ✎ TEXT
                        </text>
                        <text
                          x={10}
                          y={50}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          Wi-Fi slow in Block B
                        </text>
                        <text
                          x={10}
                          y={68}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Neha G · Room 206-B
                        </text>
                        <text
                          x={10}
                          y={85}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={10}
                          fill="#888780"
                        >
                          12 min ago
                        </text>
                      </g>
                      <rect
                        x={356}
                        y={0}
                        width={340}
                        height={446}
                        rx={10}
                        fill="#f5f5f3"
                      />
                      <text
                        x={372}
                        y={28}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fontWeight={700}
                        fill="#185FA5"
                        letterSpacing="0.06em"
                      >
                        ASSIGNED · 3
                      </text>
                      <g transform="translate(368,42)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={100}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                        />
                        <rect
                          x={10}
                          y={10}
                          width={56}
                          height={18}
                          rx={4}
                          fill="#FAEEDA"
                        />
                        <text
                          x={38}
                          y={22}
                          textAnchor="middle"
                          fontFamily="Plus Jakarta Sans"
                          fontSize={9}
                          fontWeight={700}
                          fill="#BA7517"
                        >
                          MEDIUM
                        </text>
                        <text
                          x={10}
                          y={50}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          Water leak · bathroom
                        </text>
                        <text
                          x={10}
                          y={68}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Alia K · Room 210-B
                        </text>
                        <text
                          x={10}
                          y={85}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={10}
                          fill="#888780"
                        >
                          → Suresh (plumber) · ETA 2 hrs
                        </text>
                      </g>
                      <g transform="translate(368,154)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={92}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                        />
                        <rect
                          x={10}
                          y={10}
                          width={52}
                          height={18}
                          rx={4}
                          fill="#EAF3DE"
                        />
                        <text
                          x={36}
                          y={22}
                          textAnchor="middle"
                          fontFamily="Plus Jakarta Sans"
                          fontSize={9}
                          fontWeight={700}
                          fill="#3B6D11"
                        >
                          LOW
                        </text>
                        <text
                          x={10}
                          y={50}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          Bulb replacement
                        </text>
                        <text
                          x={10}
                          y={68}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Tara S · Room 208-A
                        </text>
                        <text
                          x={10}
                          y={85}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={10}
                          fill="#888780"
                        >
                          → Maintenance · today
                        </text>
                      </g>
                      <g transform="translate(368,258)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={92}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                        />
                        <rect
                          x={10}
                          y={10}
                          width={52}
                          height={18}
                          rx={4}
                          fill="#EAF3DE"
                        />
                        <text
                          x={36}
                          y={22}
                          textAnchor="middle"
                          fontFamily="Plus Jakarta Sans"
                          fontSize={9}
                          fontWeight={700}
                          fill="#3B6D11"
                        >
                          LOW
                        </text>
                        <text
                          x={10}
                          y={50}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          Door handle loose
                        </text>
                        <text
                          x={10}
                          y={68}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Megha T · Room 210-A
                        </text>
                        <text
                          x={10}
                          y={85}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={10}
                          fill="#888780"
                        >
                          → Maintenance · tomorrow
                        </text>
                      </g>
                      <rect
                        x={712}
                        y={0}
                        width={340}
                        height={446}
                        rx={10}
                        fill="#f5f5f3"
                      />
                      <text
                        x={728}
                        y={28}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={11}
                        fontWeight={700}
                        fill="#0F6E56"
                        letterSpacing="0.06em"
                      >
                        RESOLVED TODAY · 4
                      </text>
                      <g transform="translate(724,42)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={72}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                          opacity="0.75"
                        />
                        <text
                          x={10}
                          y={24}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={600}
                          fill="#1a1a18"
                        >
                          Geyser not heating
                        </text>
                        <text
                          x={10}
                          y={42}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Vikram K · resolved in 1.8 hrs
                        </text>
                        <text
                          x={10}
                          y={60}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#BA7517"
                        >
                          ★★★★★
                        </text>
                      </g>
                      <g transform="translate(724,126)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={72}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                          opacity="0.75"
                        />
                        <text
                          x={10}
                          y={24}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={600}
                          fill="#1a1a18"
                        >
                          Extra bedsheet request
                        </text>
                        <text
                          x={10}
                          y={42}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Sanya L · resolved in 22 min
                        </text>
                        <text
                          x={10}
                          y={60}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#BA7517"
                        >
                          ★★★★★
                        </text>
                      </g>
                      <g transform="translate(724,210)">
                        <rect
                          x={0}
                          y={0}
                          width={316}
                          height={72}
                          rx={8}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.08)"
                          opacity="0.75"
                        />
                        <text
                          x={10}
                          y={24}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={13}
                          fontWeight={600}
                          fill="#1a1a18"
                        >
                          Food — less spicy pls
                        </text>
                        <text
                          x={10}
                          y={42}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#5f5e5a"
                        >
                          Kavya P · routed to kitchen
                        </text>
                        <text
                          x={10}
                          y={60}
                          fontFamily="Plus Jakarta Sans"
                          fontSize={11}
                          fill="#BA7517"
                        >
                          ★★★★☆
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="showcase-panel" data-panel="tab-vacate">
                  <svg
                    className="mock"
                    viewBox="0 0 1100 560"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width={1100} height={560} fill="#fff" rx={14} />
                    <g transform="translate(24,24)">
                      <text
                        x={0}
                        y={24}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={18}
                        fontWeight={700}
                        fill="#1a1a18"
                      >
                        Vacate workflow · Arjun Mehta
                      </text>
                      <text
                        x={0}
                        y={44}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={12}
                        fill="#5f5e5a"
                      >
                        Bed 210-A · UrbanNest PG · Notice received Apr 15 · Move
                        out May 15
                      </text>
                    </g>
                    <g transform="translate(24,90)">
                      <rect
                        x={0}
                        y={0}
                        width={1052}
                        height={88}
                        rx={10}
                        fill="#f5f5f3"
                      />
                      <g fontFamily="Plus Jakarta Sans">
                        <circle cx={100} cy={44} r={20} fill="#0F6E56" />
                        <text
                          x={100}
                          y={50}
                          textAnchor="middle"
                          fill="#fff"
                          fontSize={15}
                          fontWeight={700}
                        >
                          ✓
                        </text>
                        <text
                          x={100}
                          y={80}
                          textAnchor="middle"
                          fontSize={11}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          Notice filed
                        </text>
                        <line
                          x1={125}
                          y1={44}
                          x2={270}
                          y2={44}
                          stroke="#0F6E56"
                          strokeWidth={2}
                        />
                        <circle cx={295} cy={44} r={20} fill="#0F6E56" />
                        <text
                          x={295}
                          y={50}
                          textAnchor="middle"
                          fill="#fff"
                          fontSize={15}
                          fontWeight={700}
                        >
                          ✓
                        </text>
                        <text
                          x={295}
                          y={80}
                          textAnchor="middle"
                          fontSize={11}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          Room inspected
                        </text>
                        <line
                          x1={320}
                          y1={44}
                          x2={465}
                          y2={44}
                          stroke="#0F6E56"
                          strokeWidth={2}
                        />
                        <circle cx={490} cy={44} r={20} fill="#BA7517" />
                        <text
                          x={490}
                          y={50}
                          textAnchor="middle"
                          fill="#fff"
                          fontSize={14}
                          fontWeight={700}
                        >
                          3
                        </text>
                        <text
                          x={490}
                          y={80}
                          textAnchor="middle"
                          fontSize={11}
                          fontWeight={700}
                          fill="#1a1a18"
                        >
                          Settlement
                        </text>
                        <line
                          x1={515}
                          y1={44}
                          x2={660}
                          y2={44}
                          stroke="rgba(0,0,0,0.15)"
                          strokeDasharray="3 3"
                        />
                        <circle
                          cx={685}
                          cy={44}
                          r={20}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.2)"
                          strokeWidth="1.5"
                        />
                        <text
                          x={685}
                          y={50}
                          textAnchor="middle"
                          fill="#888780"
                          fontSize={14}
                          fontWeight={700}
                        >
                          4
                        </text>
                        <text
                          x={685}
                          y={80}
                          textAnchor="middle"
                          fontSize={11}
                          fontWeight={600}
                          fill="#888780"
                        >
                          Deposit refund
                        </text>
                        <line
                          x1={710}
                          y1={44}
                          x2={855}
                          y2={44}
                          stroke="rgba(0,0,0,0.15)"
                          strokeDasharray="3 3"
                        />
                        <circle
                          cx={880}
                          cy={44}
                          r={20}
                          fill="#fff"
                          stroke="rgba(0,0,0,0.2)"
                          strokeWidth="1.5"
                        />
                        <text
                          x={880}
                          y={50}
                          textAnchor="middle"
                          fill="#888780"
                          fontSize={14}
                          fontWeight={700}
                        >
                          5
                        </text>
                        <text
                          x={880}
                          y={80}
                          textAnchor="middle"
                          fontSize={11}
                          fontWeight={600}
                          fill="#888780"
                        >
                          Re-listed
                        </text>
                      </g>
                    </g>
                    <g transform="translate(24,204)">
                      <rect
                        x={0}
                        y={0}
                        width={660}
                        height={320}
                        rx={10}
                        fill="#fff"
                        stroke="rgba(0,0,0,0.08)"
                      />
                      <text
                        x={24}
                        y={32}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={14}
                        fontWeight={700}
                        fill="#1a1a18"
                      >
                        Final settlement
                      </text>
                      <g fontFamily="Plus Jakarta Sans" fontSize={13}>
                        <text x={24} y={72} fill="#5f5e5a">
                          Deposit held
                        </text>
                        <text
                          x={636}
                          y={72}
                          textAnchor="end"
                          fill="#1a1a18"
                          fontWeight={600}
                        >
                          + ₹22,000
                        </text>
                        <line
                          x1={24}
                          y1={86}
                          x2={636}
                          y2={86}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <text x={24} y={110} fill="#5f5e5a">
                          Pending rent (1–15 May)
                        </text>
                        <text
                          x={636}
                          y={110}
                          textAnchor="end"
                          fill="#A32D2D"
                          fontWeight={600}
                        >
                          − ₹5,500
                        </text>
                        <line
                          x1={24}
                          y1={124}
                          x2={636}
                          y2={124}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <text x={24} y={148} fill="#5f5e5a">
                          Electricity (Apr reading)
                        </text>
                        <text
                          x={636}
                          y={148}
                          textAnchor="end"
                          fill="#A32D2D"
                          fontWeight={600}
                        >
                          − ₹380
                        </text>
                        <line
                          x1={24}
                          y1={162}
                          x2={636}
                          y2={162}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <text x={24} y={186} fill="#5f5e5a">
                          Room damage (chair)
                        </text>
                        <text
                          x={636}
                          y={186}
                          textAnchor="end"
                          fill="#A32D2D"
                          fontWeight={600}
                        >
                          − ₹800
                        </text>
                        <line
                          x1={24}
                          y1={200}
                          x2={636}
                          y2={200}
                          stroke="rgba(0,0,0,0.05)"
                        />
                        <text x={24} y={224} fill="#5f5e5a">
                          Good conduct bonus
                        </text>
                        <text
                          x={636}
                          y={224}
                          textAnchor="end"
                          fill="#3B6D11"
                          fontWeight={600}
                        >
                          + ₹0
                        </text>
                      </g>
                      <rect
                        x={24}
                        y={250}
                        width={612}
                        height={48}
                        rx={8}
                        fill="#E1F5EE"
                      />
                      <text
                        x={40}
                        y={280}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={14}
                        fontWeight={700}
                        fill="#0F6E56"
                      >
                        Refundable to Arjun
                      </text>
                      <text
                        x={620}
                        y={280}
                        textAnchor="end"
                        fontFamily="Plus Jakarta Sans"
                        fontSize={20}
                        fontWeight={800}
                        fill="#0F6E56"
                      >
                        ₹15,320
                      </text>
                    </g>
                    <g transform="translate(700,204)">
                      <rect
                        x={0}
                        y={0}
                        width={376}
                        height={320}
                        rx={10}
                        fill="#fff"
                        stroke="rgba(0,0,0,0.08)"
                      />
                      <text
                        x={20}
                        y={32}
                        fontFamily="Plus Jakarta Sans"
                        fontSize={14}
                        fontWeight={700}
                        fill="#1a1a18"
                      >
                        Next steps — automated
                      </text>
                      <g fontFamily="Plus Jakarta Sans" fontSize={12}>
                        <rect
                          x={20}
                          y={52}
                          width={336}
                          height={56}
                          rx={8}
                          fill="#f5f5f3"
                        />
                        <text x={36} y={74} fontWeight={600} fill="#1a1a18">
                          1. Tenant approves settlement
                        </text>
                        <text x={36} y={92} fill="#5f5e5a">
                          Link sent via WhatsApp &amp; email
                        </text>
                        <rect
                          x={20}
                          y={116}
                          width={336}
                          height={56}
                          rx={8}
                          fill="#f5f5f3"
                        />
                        <text x={36} y={138} fontWeight={600} fill="#1a1a18">
                          2. Refund auto-processed to UPI
                        </text>
                        <text x={36} y={156} fill="#5f5e5a">
                          Within 48 hrs of approval
                        </text>
                        <rect
                          x={20}
                          y={180}
                          width={336}
                          height={56}
                          rx={8}
                          fill="#f5f5f3"
                        />
                        <text x={36} y={202} fontWeight={600} fill="#1a1a18">
                          3. Bed 210-A re-listed
                        </text>
                        <text x={36} y={220} fill="#5f5e5a">
                          On your website + 4 partners
                        </text>
                        <rect
                          x={20}
                          y={244}
                          width={336}
                          height={56}
                          rx={8}
                          fill="#f5f5f3"
                        />
                        <text x={36} y={266} fontWeight={600} fill="#1a1a18">
                          4. No-dues letter issued
                        </text>
                        <text x={36} y={284} fill="#5f5e5a">
                          PDF + digital record
                        </text>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* STATS */}
        <section className="stats">
          <div className="wrap stats-row">
            <div>
              <div className="stats-num">1,200+</div>
              <div className="stats-lbl">Properties using NestManager</div>
            </div>
            <div>
              <div className="stats-num">₹42 Cr+</div>
              <div className="stats-lbl">Rent collected last quarter</div>
            </div>
            <div>
              <div className="stats-num">94%</div>
              <div className="stats-lbl">Tenant satisfaction score</div>
            </div>
            <div>
              <div className="stats-num">10 min</div>
              <div className="stats-lbl">Average time to go live</div>
            </div>
          </div>
        </section>
        {/* TESTIMONIALS */}
        <section className="testimonials">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">
                <span className="dot" />
                Owners talking
              </span>
              <h2>People who stopped running their PG on WhatsApp.</h2>
              <p>
                Real feedback from property owners across Bengaluru, Pune,
                Hyderabad, and Delhi NCR.
              </p>
            </div>
            <div className="tst-grid">
              <div className="tst">
                <div className="tst-stars">★★★★★</div>
                <div className="tst-quote">
                  "I was running 48 beds on a diary and three Excel files.
                  Switched to MyRentMitra in a weekend. Last month was the first
                  time in four years my rent collection hit 100% by day 5."
                </div>
                <div className="tst-who">
                  <div className="tst-avatar" style={{ background: "#185FA5" }}>
                    RV
                  </div>
                  <div>
                    <div className="n">Rohit Venkatesh</div>
                    <div className="r">Owner · UrbanNest PG, Bengaluru</div>
                  </div>
                </div>
              </div>
              <div className="tst">
                <div className="tst-stars">★★★★★</div>
                <div className="tst-quote">
                  "The voice-ticket feature is gold. My tenants are mostly
                  working professionals — they'll drop a 20-second voice note at
                  11pm instead of typing. Zero complaints get lost now."
                </div>
                <div className="tst-who">
                  <div className="tst-avatar" style={{ background: "#0F6E56" }}>
                    SN
                  </div>
                  <div>
                    <div className="n">Sheetal Nair</div>
                    <div className="r">Founder · Nivaas Stays, Pune</div>
                  </div>
                </div>
              </div>
              <div className="tst">
                <div className="tst-stars">★★★★★</div>
                <div className="tst-quote">
                  "Food management alone saved me 3 hours a day. Kitchen gets
                  the exact count every morning, guest meals are tracked, and my
                  food cost dropped 18% because we stopped over-prepping."
                </div>
                <div className="tst-who">
                  <div className="tst-avatar" style={{ background: "#BA7517" }}>
                    AK
                  </div>
                  <div>
                    <div className="n">Amit Kulkarni</div>
                    <div className="r">Operator · 3 PGs, Hyderabad</div>
                  </div>
                </div>
              </div>
              <div className="tst">
                <div className="tst-stars">★★★★★</div>
                <div className="tst-quote">
                  "I own 6 rental flats, not a PG. Thought MyRentMitra was only
                  for hostels. The tenant + billing side works perfectly for
                  landlords too. Rent, deposits, renewals — one place."
                </div>
                <div className="tst-who">
                  <div className="tst-avatar" style={{ background: "#534AB7" }}>
                    DM
                  </div>
                  <div>
                    <div className="n">Deepa Mohan</div>
                    <div className="r">Landlord · Whitefield, Bengaluru</div>
                  </div>
                </div>
              </div>
              <div className="tst">
                <div className="tst-stars">★★★★★</div>
                <div className="tst-quote">
                  "Vacate settlements used to be a fight every time. Now the
                  system shows the tenant a clear breakdown — deposit, damages,
                  pending rent — and they approve on WhatsApp. Zero drama."
                </div>
                <div className="tst-who">
                  <div className="tst-avatar" style={{ background: "#A32D2D" }}>
                    PT
                  </div>
                  <div>
                    <div className="n">Priyanka Thakur</div>
                    <div className="r">Manager · StayHQ, Delhi NCR</div>
                  </div>
                </div>
              </div>
              <div className="tst">
                <div className="tst-stars">★★★★★</div>
                <div className="tst-quote">
                  "The UI is the first PG app that doesn't look like it was
                  built in 2014. My staff picked it up without any training.
                  That alone was worth the switch."
                </div>
                <div className="tst-who">
                  <div className="tst-avatar" style={{ background: "#3B6D11" }}>
                    KR
                  </div>
                  <div>
                    <div className="n">Karan Reddy</div>
                    <div className="r">Ops Head · ShelterCo, Bengaluru</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* PRICING (home) */}
        <section className="pricing" id="home-pricing">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">
                <span className="dot" />
                Pricing
              </span>
              <h2>Pay for beds, not seats.</h2>
              <p>
                Every plan includes unlimited tenants, unlimited properties, and
                unlimited users. You pay only for beds under management.
              </p>
              <div className="pricing-toggle">
                <button
                  className="active"
                  data-cycle="monthly"
                  onclick="togglePricing('monthly')"
                >
                  Monthly
                </button>
                <button data-cycle="yearly" onclick="togglePricing('yearly')">
                  Yearly <span className="save">Save 20%</span>
                </button>
              </div>
            </div>
            <div className="plans">
              <div className="plan">
                <div className="plan-name">Starter</div>
                <div className="plan-sub">
                  For single-property owners getting off notebooks.
                </div>
                <div className="plan-price">
                  <span className="cur">₹</span>
                  <span
                    className="amt"
                    data-price=""
                    data-monthly={12}
                    data-yearly={10}
                  >
                    12
                  </span>
                  <span className="per">/ bed / month</span>
                </div>
                <div className="plan-note">Up to 30 beds · ₹360/mo minimum</div>
                <hr />
                <ul className="plan-feats">
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Bed-level inventory &amp; tenant records</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Auto rent cycles + UPI collection</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Text complaints + ticket workflow</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>SMS reminders (500/month)</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Email support</span>
                  </li>
                </ul>
                <button className="btn" onclick="goTo('auth','signup')">
                  Start free trial
                </button>
              </div>
              <div className="plan plan-featured">
                <div className="plan-badge">Most popular</div>
                <div className="plan-name">Growth</div>
                <div className="plan-sub">
                  For operators running 2–10 properties with staff.
                </div>
                <div className="plan-price">
                  <span className="cur">₹</span>
                  <span
                    className="amt"
                    data-price=""
                    data-monthly={20}
                    data-yearly={16}
                  >
                    20
                  </span>
                  <span className="per">/ bed / month</span>
                </div>
                <div className="plan-note">
                  Up to 250 beds · 5 staff accounts
                </div>
                <hr />
                <ul className="plan-feats">
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Everything in Starter</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Food management &amp; kitchen counts</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Voice tickets with AI transcription</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>WhatsApp Business integration</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Analytics + cross-property reports</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Priority chat support (9am–9pm)</span>
                  </li>
                </ul>
                <button
                  className="btn btn-primary"
                  onclick="goTo('auth','signup')"
                >
                  Start free trial
                </button>
              </div>
              <div className="plan">
                <div className="plan-name">Pro</div>
                <div className="plan-sub">
                  For chains, real estate operators, and enterprises.
                </div>
                <div className="plan-price">
                  <span className="cur">₹</span>
                  <span
                    className="amt"
                    data-price=""
                    data-monthly={32}
                    data-yearly={26}
                  >
                    32
                  </span>
                  <span className="per">/ bed / month</span>
                </div>
                <div className="plan-note">
                  Unlimited beds · unlimited staff · custom SLA
                </div>
                <hr />
                <ul className="plan-feats">
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Everything in Growth</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Multi-branch hierarchy &amp; roles</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>API access + Zapier/Make integrations</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Tally / Zoho Books sync</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>White-label tenant portal</span>
                  </li>
                  <li className="plan-feat">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6L9 17l-5-5" />
                    </svg>
                    <span>Dedicated account manager</span>
                  </li>
                </ul>
                <button className="btn" onclick="goTo('contact')">
                  Talk to sales
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* FAQ */}
        <section className="faq">
          <div className="wrap">
            <div className="section-head">
              <span className="eyebrow">
                <span className="dot" />
                FAQ
              </span>
              <h2>Honest answers.</h2>
            </div>
            <div className="faq-list">
              <details className="faq-item" open="">
                <summary>How long does setup actually take?</summary>
                <div className="faq-a">
                  For a single 30-bed PG: about 10 minutes. You map your rooms
                  and beds, paste tenants from Excel (we auto-fill KYC via
                  DigiLocker if they're already added), and you're live. For
                  multi-property chains with 500+ beds, our team will do the
                  migration for you — typically 48 hours end-to-end.
                </div>
              </details>
              <details className="faq-item">
                <summary>
                  I don't run a PG — I have rental flats. Will this work?
                </summary>
                <div className="faq-a">
                  Yes. The bed-level inventory is optional. If you have 6 flats,
                  you can treat each flat as a unit with one "bed." Everything
                  around tenants, billing, KYC, complaints, and vacate flows
                  works identically for landlords.
                </div>
              </details>
              <details className="faq-item">
                <summary>Do my tenants need to install anything?</summary>
                <div className="faq-a">
                  No. They receive payment links, receipts, and notice
                  confirmations via WhatsApp, SMS, or email — whichever you
                  enable. There's an optional tenant web portal (no app install)
                  for those who want to see their history or raise tickets.
                </div>
              </details>
              <details className="faq-item">
                <summary>What about payment gateway charges?</summary>
                <div className="faq-a">
                  UPI collections are free (0% fee) on Starter and Growth plans
                  — we pass through the PG's NPCI rates. Cards and net-banking
                  are at standard Razorpay rates (around 2%). You can pass fees
                  to tenants or absorb them; it's configurable per payment mode.
                </div>
              </details>
              <details className="faq-item">
                <summary>Can I cancel anytime?</summary>
                <div className="faq-a">
                  Yes, month-to-month, no lock-in. On cancellation, you can
                  export all your data (tenants, payments, tickets) as CSV or
                  JSON. We keep backups for 90 days in case you change your
                  mind.
                </div>
              </details>
              <details className="faq-item">
                <summary>Is my tenant data safe?</summary>
                <div className="faq-a">
                  Data is encrypted in transit (TLS 1.3) and at rest (AES-256).
                  We're hosted on AWS Mumbai with daily snapshots. We're SOC 2
                  Type II in progress and fully DPDP Act 2023 compliant. We
                  never sell or share tenant data — full stop.
                </div>
              </details>
              <details className="faq-item">
                <summary>What languages is it available in?</summary>
                <div className="faq-a">
                  The dashboard is currently in English. Tenant-facing messages
                  (SMS, WhatsApp, payment receipts, portal) support English,
                  Hindi, Kannada, Tamil, Telugu, and Marathi. More languages on
                  request for Growth and Pro plans.
                </div>
              </details>
            </div>
          </div>
        </section>
        {/* CTA BANNER */}
        <section className="cta-banner">
          <div className="cta-inner">
            <span
              className="eyebrow"
              style={{
                background: "rgba(255,255,255,0.08)",
                color: "rgba(255,255,255,0.8)",
                borderColor: "rgba(255,255,255,0.15)",
              }}
            >
              <span className="dot" />
              Start free
            </span>
            <h2 style={{ marginTop: 20 }}>Your notebook can't do this.</h2>
            <p>
              Spin up MyRentMitra in 10 minutes. Run your next billing cycle on
              it. If it doesn't save you 10 hours in the first month, keep your
              notebook — we'll refund you.
            </p>
            <div
              style={{
                display: "flex",
                gap: 12,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                className="btn btn-primary btn-lg"
                onclick="goTo('auth','signup')"
              >
                Start 14-day free trial
                <svg
                  className="arrow"
                  width={14}
                  height={14}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </button>
              <button
                className="btn btn-ghost btn-lg"
                onclick="goTo('contact')"
              >
                Book a 20-min demo
              </button>
            </div>
            <div className="cta-hint">
              No credit card · Cancel anytime · Your data stays yours
            </div>
          </div>
        </section>
      </div>

      <WebFooter />
    </>
  );
}
